import _defineProperty from "/src/node_modules/.pnpm/@babel+runtime@7.8.3/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/src/node_modules/.pnpm/@babel+runtime@7.8.3/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/src/node_modules/.pnpm/@babel+runtime@7.8.3/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["__scopePopper", "virtualRef"],
    _excluded2 = ["__scopePopper", "side", "sideOffset", "align", "alignOffset", "arrowPadding", "collisionBoundary", "collisionPadding", "sticky", "hideWhenDetached", "avoidCollisions"],
    _excluded3 = ["__scopePopper"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import $kY93V$babelruntimehelpersesmextends from "@babel/runtime/helpers/esm/extends";
import { useState as $kY93V$useState, createElement as $kY93V$createElement, forwardRef as $kY93V$forwardRef, useRef as $kY93V$useRef, useEffect as $kY93V$useEffect, useLayoutEffect as $kY93V$useLayoutEffect } from "react";
import { useFloating as $kY93V$useFloating, autoUpdate as $kY93V$autoUpdate, offset as $kY93V$offset, shift as $kY93V$shift, limitShift as $kY93V$limitShift, arrow as $kY93V$arrow, flip as $kY93V$flip, hide as $kY93V$hide } from "@floating-ui/react-dom";
import { Root as $kY93V$Root } from "@radix-ui/react-arrow";
import { useComposedRefs as $kY93V$useComposedRefs } from "@radix-ui/react-compose-refs";
import { createContextScope as $kY93V$createContextScope } from "@radix-ui/react-context";
import { Primitive as $kY93V$Primitive } from "@radix-ui/react-primitive";
import { useLayoutEffect as $kY93V$useLayoutEffect1 } from "@radix-ui/react-use-layout-effect";
import { useSize as $kY93V$useSize } from "@radix-ui/react-use-size";
var $cf1ac5d9fe0e8206$export$36f0086da09c4b9f = ['top', 'right', 'bottom', 'left'];
var $cf1ac5d9fe0e8206$export$3671ffab7b302fc9 = ['start', 'center', 'end'];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/

var $cf1ac5d9fe0e8206$var$POPPER_NAME = 'Popper';

var _$kY93V$createContext = $kY93V$createContextScope($cf1ac5d9fe0e8206$var$POPPER_NAME),
    _$kY93V$createContext2 = _slicedToArray(_$kY93V$createContext, 2),
    $cf1ac5d9fe0e8206$var$createPopperContext = _$kY93V$createContext2[0],
    $cf1ac5d9fe0e8206$export$722aac194ae923 = _$kY93V$createContext2[1];

var _$cf1ac5d9fe0e8206$va = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$POPPER_NAME),
    _$cf1ac5d9fe0e8206$va2 = _slicedToArray(_$cf1ac5d9fe0e8206$va, 2),
    $cf1ac5d9fe0e8206$var$PopperProvider = _$cf1ac5d9fe0e8206$va2[0],
    $cf1ac5d9fe0e8206$var$usePopperContext = _$cf1ac5d9fe0e8206$va2[1];

var $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9 = function $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9(props) {
  var __scopePopper = props.__scopePopper,
      children = props.children;

  var _$kY93V$useState = $kY93V$useState(null),
      _$kY93V$useState2 = _slicedToArray(_$kY93V$useState, 2),
      anchor = _$kY93V$useState2[0],
      setAnchor = _$kY93V$useState2[1];

  return /*#__PURE__*/$kY93V$createElement($cf1ac5d9fe0e8206$var$PopperProvider, {
    scope: __scopePopper,
    anchor: anchor,
    onAnchorChange: setAnchor
  }, children);
};
/*#__PURE__*/


Object.assign($cf1ac5d9fe0e8206$export$badac9ada3a0bdf9, {
  displayName: $cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/

var $cf1ac5d9fe0e8206$var$ANCHOR_NAME = 'PopperAnchor';
var $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d = /*#__PURE__*/$kY93V$forwardRef(function (props, forwardedRef) {
  var __scopePopper = props.__scopePopper,
      virtualRef = props.virtualRef,
      anchorProps = _objectWithoutProperties(props, _excluded);

  var context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
  var ref = $kY93V$useRef(null);
  var composedRefs = $kY93V$useComposedRefs(forwardedRef, ref);
  $kY93V$useEffect(function () {
    // Consumer can anchor the popper to something that isn't
    // a DOM node e.g. pointer position, so we override the
    // `anchorRef` with their virtual ref in this case.
    context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
  });
  return virtualRef ? null : /*#__PURE__*/$kY93V$createElement($kY93V$Primitive.div, $kY93V$babelruntimehelpersesmextends({}, anchorProps, {
    ref: composedRefs
  }));
});
/*#__PURE__*/

Object.assign($cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d, {
  displayName: $cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/

var $cf1ac5d9fe0e8206$var$CONTENT_NAME = 'PopperContent';

var _$cf1ac5d9fe0e8206$va3 = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME),
    _$cf1ac5d9fe0e8206$va4 = _slicedToArray(_$cf1ac5d9fe0e8206$va3, 2),
    $cf1ac5d9fe0e8206$var$PopperContentProvider = _$cf1ac5d9fe0e8206$va4[0],
    $cf1ac5d9fe0e8206$var$useContentContext = _$cf1ac5d9fe0e8206$va4[1];

var _$cf1ac5d9fe0e8206$va5 = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, {
  hasParent: false,
  positionUpdateFns: new Set()
}),
    _$cf1ac5d9fe0e8206$va6 = _slicedToArray(_$cf1ac5d9fe0e8206$va5, 2),
    $cf1ac5d9fe0e8206$var$PositionContextProvider = _$cf1ac5d9fe0e8206$va6[0],
    $cf1ac5d9fe0e8206$var$usePositionContext = _$cf1ac5d9fe0e8206$va6[1];

var $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc = /*#__PURE__*/$kY93V$forwardRef(function (props, forwardedRef) {
  var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$hide, _middlewareData$trans, _middlewareData$trans2;

  var __scopePopper = props.__scopePopper,
      _props$side = props.side,
      side = _props$side === void 0 ? 'bottom' : _props$side,
      _props$sideOffset = props.sideOffset,
      sideOffset = _props$sideOffset === void 0 ? 0 : _props$sideOffset,
      _props$align = props.align,
      align = _props$align === void 0 ? 'center' : _props$align,
      _props$alignOffset = props.alignOffset,
      alignOffset = _props$alignOffset === void 0 ? 0 : _props$alignOffset,
      _props$arrowPadding = props.arrowPadding,
      arrowPadding = _props$arrowPadding === void 0 ? 0 : _props$arrowPadding,
      _props$collisionBound = props.collisionBoundary,
      collisionBoundary = _props$collisionBound === void 0 ? [] : _props$collisionBound,
      _props$collisionPaddi = props.collisionPadding,
      collisionPaddingProp = _props$collisionPaddi === void 0 ? 0 : _props$collisionPaddi,
      _props$sticky = props.sticky,
      sticky = _props$sticky === void 0 ? 'partial' : _props$sticky,
      _props$hideWhenDetach = props.hideWhenDetached,
      hideWhenDetached = _props$hideWhenDetach === void 0 ? false : _props$hideWhenDetach,
      _props$avoidCollision = props.avoidCollisions,
      avoidCollisions = _props$avoidCollision === void 0 ? true : _props$avoidCollision,
      contentProps = _objectWithoutProperties(props, _excluded2);

  var context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);

  var _$kY93V$useState3 = $kY93V$useState(null),
      _$kY93V$useState4 = _slicedToArray(_$kY93V$useState3, 2),
      content = _$kY93V$useState4[0],
      setContent = _$kY93V$useState4[1];

  var composedRefs = $kY93V$useComposedRefs(forwardedRef, function (node) {
    return setContent(node);
  });

  var _$kY93V$useState5 = $kY93V$useState(null),
      _$kY93V$useState6 = _slicedToArray(_$kY93V$useState5, 2),
      arrow = _$kY93V$useState6[0],
      setArrow = _$kY93V$useState6[1];

  var arrowSize = $kY93V$useSize(arrow);
  var arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
  var arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
  var desiredPlacement = side + (align !== 'center' ? '-' + align : '');
  var collisionPadding = typeof collisionPaddingProp === 'number' ? collisionPaddingProp : _objectSpread({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, collisionPaddingProp);
  var boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [collisionBoundary];
  var hasExplicitBoundaries = boundary.length > 0;
  var detectOverflowOptions = {
    padding: collisionPadding,
    boundary: boundary.filter($cf1ac5d9fe0e8206$var$isNotNull),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: hasExplicitBoundaries
  };

  var _$kY93V$useFloating = $kY93V$useFloating({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: 'fixed',
    placement: desiredPlacement,
    whileElementsMounted: $kY93V$autoUpdate,
    middleware: [$kY93V$offset({
      mainAxis: sideOffset + arrowHeight,
      alignmentAxis: alignOffset
    }), avoidCollisions ? $kY93V$shift(_objectSpread({
      mainAxis: true,
      crossAxis: false,
      limiter: sticky === 'partial' ? $kY93V$limitShift() : undefined
    }, detectOverflowOptions)) : undefined, arrow ? $kY93V$arrow({
      element: arrow,
      padding: arrowPadding
    }) : undefined, avoidCollisions ? $kY93V$flip(_objectSpread({}, detectOverflowOptions)) : undefined, $cf1ac5d9fe0e8206$var$transformOrigin({
      arrowWidth: arrowWidth,
      arrowHeight: arrowHeight
    }), hideWhenDetached ? $kY93V$hide({
      strategy: 'referenceHidden'
    }) : undefined].filter($cf1ac5d9fe0e8206$var$isDefined)
  }),
      reference = _$kY93V$useFloating.reference,
      floating = _$kY93V$useFloating.floating,
      strategy = _$kY93V$useFloating.strategy,
      x = _$kY93V$useFloating.x,
      y = _$kY93V$useFloating.y,
      placement = _$kY93V$useFloating.placement,
      middlewareData = _$kY93V$useFloating.middlewareData,
      update = _$kY93V$useFloating.update; // assign the reference dynamically once `Content` has mounted so we can collocate the logic


  $kY93V$useLayoutEffect1(function () {
    reference(context.anchor);
  }, [reference, context.anchor]);
  var isPlaced = x !== null && y !== null;

  var _$cf1ac5d9fe0e8206$va7 = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement),
      _$cf1ac5d9fe0e8206$va8 = _slicedToArray(_$cf1ac5d9fe0e8206$va7, 2),
      placedSide = _$cf1ac5d9fe0e8206$va8[0],
      placedAlign = _$cf1ac5d9fe0e8206$va8[1];

  var arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
  var arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
  var cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;

  var _$kY93V$useState7 = $kY93V$useState(),
      _$kY93V$useState8 = _slicedToArray(_$kY93V$useState7, 2),
      contentZIndex = _$kY93V$useState8[0],
      setContentZIndex = _$kY93V$useState8[1];

  $kY93V$useLayoutEffect1(function () {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [content]);

  var _$cf1ac5d9fe0e8206$va9 = $cf1ac5d9fe0e8206$var$usePositionContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper),
      hasParent = _$cf1ac5d9fe0e8206$va9.hasParent,
      positionUpdateFns = _$cf1ac5d9fe0e8206$va9.positionUpdateFns;

  var isRoot = !hasParent;
  $kY93V$useLayoutEffect(function () {
    if (!isRoot) {
      positionUpdateFns.add(update);
      return function () {
        positionUpdateFns.delete(update);
      };
    }
  }, [isRoot, positionUpdateFns, update]); // when nested contents are rendered in portals, they are appended out of order causing
  // children to be positioned incorrectly if initially open.
  // we need to re-compute the positioning once the parent has finally been placed.
  // https://github.com/floating-ui/floating-ui/issues/1531

  $kY93V$useLayoutEffect(function () {
    if (isRoot && isPlaced) Array.from(positionUpdateFns).reverse().forEach(function (fn) {
      return requestAnimationFrame(fn);
    });
  }, [isRoot, isPlaced, positionUpdateFns]);

  var commonProps = _objectSpread(_objectSpread({
    'data-side': placedSide,
    'data-align': placedAlign
  }, contentProps), {}, {
    ref: composedRefs,
    style: _objectSpread(_objectSpread({}, contentProps.style), {}, {
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: !isPlaced ? 'none' : undefined,
      // hide the content if using the hide middleware and should be hidden
      opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
    })
  });

  return /*#__PURE__*/$kY93V$createElement("div", {
    ref: floating,
    "data-radix-popper-content-wrapper": "",
    style: _defineProperty({
      position: strategy,
      left: 0,
      top: 0,
      transform: isPlaced ? "translate3d(".concat(Math.round(x), "px, ").concat(Math.round(y), "px, 0)") : 'translate3d(0, -200%, 0)',
      // keep off the page when measuring
      minWidth: 'max-content',
      zIndex: contentZIndex
    }, '--radix-popper-transform-origin', [(_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x, (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y].join(' '))
  }, /*#__PURE__*/$kY93V$createElement($cf1ac5d9fe0e8206$var$PopperContentProvider, {
    scope: __scopePopper,
    placedSide: placedSide,
    onArrowChange: setArrow,
    arrowX: arrowX,
    arrowY: arrowY,
    shouldHideArrow: cannotCenterArrow
  }, isRoot ? /*#__PURE__*/$kY93V$createElement($cf1ac5d9fe0e8206$var$PositionContextProvider, {
    scope: __scopePopper,
    hasParent: true,
    positionUpdateFns: positionUpdateFns
  }, /*#__PURE__*/$kY93V$createElement($kY93V$Primitive.div, commonProps)) : /*#__PURE__*/$kY93V$createElement($kY93V$Primitive.div, commonProps)));
});
/*#__PURE__*/

Object.assign($cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc, {
  displayName: $cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/

var $cf1ac5d9fe0e8206$var$ARROW_NAME = 'PopperArrow';
var $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
  top: 'bottom',
  right: 'left',
  bottom: 'top',
  left: 'right'
};
var $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0 = /*#__PURE__*/$kY93V$forwardRef(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
  var _style2;

  var __scopePopper = props.__scopePopper,
      arrowProps = _objectWithoutProperties(props, _excluded3);

  var contentContext = $cf1ac5d9fe0e8206$var$useContentContext($cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
  var baseSide = $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
  return (
    /*#__PURE__*/
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    $kY93V$createElement("span", {
      ref: contentContext.onArrowChange,
      style: (_style2 = {
        position: 'absolute',
        left: contentContext.arrowX,
        top: contentContext.arrowY
      }, _defineProperty(_style2, baseSide, 0), _defineProperty(_style2, "transformOrigin", {
        top: '',
        right: '0 0',
        bottom: 'center 0',
        left: '100% 0'
      }[contentContext.placedSide]), _defineProperty(_style2, "transform", {
        top: 'translateY(100%)',
        right: 'translateY(50%) rotate(90deg) translateX(-50%)',
        bottom: "rotate(180deg)",
        left: 'translateY(50%) rotate(-90deg) translateX(50%)'
      }[contentContext.placedSide]), _defineProperty(_style2, "visibility", contentContext.shouldHideArrow ? 'hidden' : undefined), _style2)
    }, /*#__PURE__*/$kY93V$createElement($kY93V$Root, $kY93V$babelruntimehelpersesmextends({}, arrowProps, {
      ref: forwardedRef,
      style: _objectSpread(_objectSpread({}, arrowProps.style), {}, {
        // ensures the element can be measured correctly (mostly for if SVG)
        display: 'block'
      })
    })))
  );
});
/*#__PURE__*/

Object.assign($cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0, {
  displayName: $cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/

function $cf1ac5d9fe0e8206$var$isDefined(value) {
  return value !== undefined;
}

function $cf1ac5d9fe0e8206$var$isNotNull(value) {
  return value !== null;
}

var $cf1ac5d9fe0e8206$var$transformOrigin = function $cf1ac5d9fe0e8206$var$transformOrigin(options) {
  return {
    name: 'transformOrigin',
    options: options,
    fn: function fn(data) {
      var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;

      var placement = data.placement,
          rects = data.rects,
          middlewareData = data.middlewareData;
      var cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
      var isArrowHidden = cannotCenterArrow;
      var arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
      var arrowHeight = isArrowHidden ? 0 : options.arrowHeight;

      var _$cf1ac5d9fe0e8206$va10 = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement),
          _$cf1ac5d9fe0e8206$va11 = _slicedToArray(_$cf1ac5d9fe0e8206$va10, 2),
          placedSide = _$cf1ac5d9fe0e8206$va11[0],
          placedAlign = _$cf1ac5d9fe0e8206$va11[1];

      var noArrowAlign = {
        start: '0%',
        center: '50%',
        end: '100%'
      }[placedAlign];
      var arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
      var arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
      var x = '';
      var y = '';

      if (placedSide === 'bottom') {
        x = isArrowHidden ? noArrowAlign : "".concat(arrowXCenter, "px");
        y = "".concat(-arrowHeight, "px");
      } else if (placedSide === 'top') {
        x = isArrowHidden ? noArrowAlign : "".concat(arrowXCenter, "px");
        y = "".concat(rects.floating.height + arrowHeight, "px");
      } else if (placedSide === 'right') {
        x = "".concat(-arrowHeight, "px");
        y = isArrowHidden ? noArrowAlign : "".concat(arrowYCenter, "px");
      } else if (placedSide === 'left') {
        x = "".concat(rects.floating.width + arrowHeight, "px");
        y = isArrowHidden ? noArrowAlign : "".concat(arrowYCenter, "px");
      }

      return {
        data: {
          x: x,
          y: y
        }
      };
    }
  };
};

function $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
  var _placement$split = placement.split('-'),
      _placement$split2 = _slicedToArray(_placement$split, 2),
      side = _placement$split2[0],
      _placement$split2$ = _placement$split2[1],
      align = _placement$split2$ === void 0 ? 'center' : _placement$split2$;

  return [side, align];
}

var $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9 = $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9;
var $cf1ac5d9fe0e8206$export$b688253958b8dfe7 = $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d;
var $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2 = $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc;
var $cf1ac5d9fe0e8206$export$21b07c8f274aebd5 = $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0;
export { $cf1ac5d9fe0e8206$export$722aac194ae923 as createPopperScope, $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9 as Popper, $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d as PopperAnchor, $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc as PopperContent, $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0 as PopperArrow, $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9 as Root, $cf1ac5d9fe0e8206$export$b688253958b8dfe7 as Anchor, $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2 as Content, $cf1ac5d9fe0e8206$export$21b07c8f274aebd5 as Arrow, $cf1ac5d9fe0e8206$export$36f0086da09c4b9f as SIDE_OPTIONS, $cf1ac5d9fe0e8206$export$3671ffab7b302fc9 as ALIGN_OPTIONS };